import Vue from 'vue'
import VueTk from '@moke/vue-tk'
import router from '@/router'
import '@moke/vue-tk/dist/vue-tk.css'
import icon from '@/assets/json/icon'

Vue.use(VueTk.tkFlex)
Vue.use(VueTk.tkIcon)
Vue.use(VueTk.tkQrcode)
Vue.use(VueTk.tkLoading)
Vue.use(VueTk.tkImage)
Vue.use(VueTk.tkCover)
Vue.use(VueTk.tkAvatar)
Vue.use(VueTk.tkHistory)
Vue.use(VueTk.tkUa)

const options = {
  vue: Vue,
  router: router,
  icon: {
    custom: {
      default: {
        data: icon,
        type: 'private',
        useClassAsName: true
      }
    }
  },
  history: {
    // none auto
    transtionMode: 'auto'
  }
}
VueTk.init(options)
